
import React, { useContext } from "react";
import i18next from "i18next";
import { useFormContext } from "react-hook-form";
import {
  Grid,
  Checkbox,
  FormControlLabel
} from "@mui/material";

import RuleSelectInput from "components/rules/RuleSelectInput";
import RuleStandardInput from "components/rules/RuleStandardInput";
import { RuleActionParameterNames, RuleActionType, RulesContext } from "services/common/RulesUtils";
import { isSealedDossier } from "services/common/Constants";
import RuleReverseActionParam from "../RuleReverseActionParam";


const DossierCreationParams = ({ actionType, fieldName, readOnly = false }) => {
  const {
    dossierTypes,
  } = useContext(RulesContext);

  const mappedDossierTypes = dossierTypes?.map(({ code, label }) => ({
    value: code !== "null" ? code : 'FREE',
    label
  }));

  const formMethods = useFormContext();
  const {
    setValue,
    getValues
  } = formMethods;

  const MAX_LENGTH = 100;

  const validateDossierTypeCode = (value) => {
  }

  const isReferenceUnique = (reference) => {
    return !(getValues("actions")
      .filter((entry) => {
        return entry.parameters[`${RuleActionParameterNames.DOSSIER_REFERENCE}`]?.trim()?.toLowerCase() === reference?.trim()?.toLowerCase()
      })
      ?.length > 1);
  }

  const validateDossierReference = (value) => {
    let isValid = false;
    let typeErrMsg = "";

    if (value.length === 0) {
      typeErrMsg = i18next.t("infos.required");
    } else if (value.length > MAX_LENGTH) {
      typeErrMsg = i18next.t(
        "rules.configuration.ruleActions.fields.parameters.dossierReference.errors.maxLengthExceeded",
        {
          length: MAX_LENGTH
        }
      );
    } else if (!isReferenceUnique(value)) {
      typeErrMsg = i18next.t("rules.configuration.ruleActions.fields.parameters.dossierReference.errors.notUnique");
    } else {
      isValid = true;
    }

    if (isValid) {
      return null;
    } else {
      return typeErrMsg;
    }
  }

  return (
    <Grid container spacing={2} style={{ alignItems: "center", justifyContent: "center" }}>
      <Grid item xs={12} md={3}>
        <RuleSelectInput
          fieldName={`${fieldName}.${RuleActionParameterNames.DOSSIER_TYPE_CODE}`}
          label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.dossierTypeCode.label")}`}
          placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.dossierTypeCode.placeholder`)}
          options={mappedDossierTypes?.filter(
            (dossierType) => 
              !isSealedDossier(dossierType.value)
          )}
          onChange={() => { }}
          isRequired
          validate={validateDossierTypeCode}
          labelVariant='chip'
          disabled={readOnly}
        />
      </Grid >

      <Grid item xs={12} md={3}>
        <RuleStandardInput
          fieldName={`${fieldName}.${RuleActionParameterNames.DOSSIER_REFERENCE}`}
          label={`${i18next.t("rules.configuration.ruleActions.fields.parameters.dossierReference.label")}`}
          placeholder={i18next.t(`rules.configuration.ruleActions.fields.parameters.dossierReference.placeholder`)}
          onChange={() => { }}
          isRequired
          variant={"outlined"}
          validate={validateDossierReference}
          disabled={readOnly}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <FormControlLabel
          sx={{
            position: "relative",
            bottom: -14,
            '.MuiFormControlLabel-label': {
              fontSize: '14px',
              position: "relative",
              bottom: -1, left: -5
            }
          }}
          control={
            <Checkbox
              disabled={readOnly}
              checked={`true` === getValues(`${fieldName}.${RuleActionParameterNames.DOSSIER_REACTIVATE_ARCHIVED}`)}
              onChange={(e) => {
                setValue(`${fieldName}.${RuleActionParameterNames.DOSSIER_REACTIVATE_ARCHIVED}`, `${e.target.checked}`)
              }}
            />
          }
          label={i18next.t(`rules.configuration.ruleActions.fields.parameters.reactivateDossier.label`)}
          onClick={(e) => e.stopPropagation()}
        />
      </Grid>
      {
        [RuleActionType.DOSSIER_CREATION, RuleActionType.ADD_DOSSIER_CONTEXT_THIRDPARTY].includes(actionType) && (
          <RuleReverseActionParam fieldName={fieldName} readOnly={readOnly}/>
        )
      }
    </Grid >
  );
}

export default DossierCreationParams;
